module.exports = __webpack_public_path__ + "media/ringtone.d21d44fc.mp3";